import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { IconProps, Icons } from './IconsRes';
import { getIconClasses } from '@/Static/IconUtils';

export function RefDocsIcon({ size = 'small', onClick }: IconProps) {
  return <img src={Icons.RefDocs} alt="img" className={cn(styles.icon, getIconClasses(size))} onClick={onClick} />;
}
